import React from 'react';
import '../styles/attributes.css';

function Empty() {
  return <div />;
}

export default Empty;
